import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	itemsCount: number;
	totalCount: number;
};

export const PaginationDetails = ({ itemsCount, totalCount }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<PaginationDetailsStyled
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			data-testid="jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details"
		>
			{formatMessage(messages.ofTotalCount, {
				itemsCount,
				totalCount,
			})}
		</PaginationDetailsStyled>
	);
};

export default PaginationDetails;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PaginationDetailsStyled = styled.div({
	textAlign: 'right',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest'),
	flexGrow: 1,
	flexShrink: 0,
	flexBasis: 'auto',
	marginTop: token('space.0'),
	marginRight: token('space.150'),
	marginBottom: token('space.0'),
	marginLeft: token('space.150'),
	font: token('font.body'),
});
